module.exports = __webpack_public_path__ + "img/new-referral-bg.7602c8c1.svg";